export const supportedCountries = ['AT', 'BE', 'CA', 'CH', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'IT', 'NL', 'NO', 'NZ', 'SE'];
export const supportedCountriesRequiringStates = ['AU'];
